import styled from '@emotion/styled';

const NavHeader = styled.div`
  padding-bottom: 8px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.zinc_200};
  margin-bottom: 16px;
`;

export default NavHeader;
